import isString from 'lodash/isString';
import { useDropzone } from 'react-dropzone';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { UploadProps } from './types';
import ImageLegacy from '../image/imageLegacy';
import RejectionFiles from './RejectionFiles';
import BlockContent from './BlockContent';
import SingleFilePreview from './SingleFilePreview';

// ----------------------------------------------------------------------

const DropZoneStyle = styled('div')(({ theme }) => ({
  outline: 'none',
  overflow: 'hidden',
  position: 'relative',
  padding: theme.spacing(5, 1),
  borderRadius: theme.shape.borderRadius,
  transition: theme.transitions.create('padding'),
  backgroundColor: theme.palette.background.neutral,
  border: `1px dashed ${theme.palette.grey[500]}`,
  '&:hover': { opacity: 0.72, cursor: 'pointer' },
}));

// ----------------------------------------------------------------------

export default function UploadSingleFileBanner({
  error = false,
  showPreview = false,
  file,
  onRemove,
  onRemoveAll,
  helperText,
  accept,
  sx,
  ...other
}: UploadProps) {
  const { getRootProps, getInputProps, isDragActive, isDragReject, fileRejections } = useDropzone({
    multiple: false,
    maxSize: 600000,
    ...other,
  });
  return (
    <Box sx={{ width: '100%', ...sx }}>
      <DropZoneStyle
        {...getRootProps()}
        sx={{
          ...(isDragActive && { opacity: 0.72 }),
          ...((isDragReject || error) && {
            color: 'error.main',
            borderColor: 'error.light',
            bgcolor: 'error.lighter',
          }),
          ...(file &&
            getInputProps().accept &&
            getInputProps().accept !== 'video/*' &&
            getInputProps().accept !== 'audio/*' && {
              padding: '12% 0',
            }),
        }}
      >
        <input {...getInputProps()} />

        <BlockContent />

        {file &&
          getInputProps().accept &&
          getInputProps().accept !== 'video/*' &&
          getInputProps().accept !== 'audio/*' && (
            <ImageLegacy
              alt="file preview"
              src={isString(file) ? file : file.urlName}
              sx={{
                top: 8,
                left: 8,
                borderRadius: 1,
                position: 'absolute',
                width: 'calc(100% - 16px)',
                height: 'calc(100% - 16px)',
              }}
            />
          )}
      </DropZoneStyle>

      {/* @ts-ignore */}
      {fileRejections.length > 0 && <RejectionFiles fileRejections={fileRejections} />}

      <SingleFilePreview
        // @ts-ignore
        file={file}
        showPreview={showPreview}
        // @ts-ignore
        onRemove={onRemove}
        // @ts-ignore
        onRemoveAll={onRemoveAll}
      />
      {helperText && helperText}
    </Box>
  );
}
